import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { COUNTRY_TYPE, COUNTRIES_AVAILABLE_VALUES } from 'shared-modules/constants';
import { removeSuffix } from 'shared-modules/hooks/symbol';
import AUDFlag from '../../assets/flags/AUD.svg';
import CADFlag from '../../assets/flags/CAD.svg';
import CHFFlag from '../../assets/flags/CHF.svg';
import EURFlag from '../../assets/flags/EUR.svg';
import GBPFlag from '../../assets/flags/GBP.svg';
import JPYFlag from '../../assets/flags/JPY.svg';
import NZDFlag from '../../assets/flags/NZD.svg';
import USDFlag from '../../assets/flags/USD.svg';
import ZARFlag from '../../assets/flags/ZAR.svg';
import TRYFlag from '../../assets/flags/TRY.svg';
import PLNFlag from '../../assets/flags/PLN.svg';
import MXNFlag from '../../assets/flags/MXN.svg';
import NOKFlag from '../../assets/flags/NOK.svg';
import SEKFlag from '../../assets/flags/SEK.svg';
import CNHFlag from '../../assets/flags/CNH.svg';
import CZKFlag from '../../assets/flags/CZK.svg';
import HUFFlag from '../../assets/flags/HUF.svg';
import SGDFlag from '../../assets/flags/SGD.svg';
import HKDFlag from '../../assets/flags/HKD.svg';

import styles from './customFlag.module.scss';

const CustomFlag = ({ country, className }) => {
  const countrySymbol = removeSuffix(country);
  const src = useMemo(() => {
    switch (countrySymbol) {
      case COUNTRY_TYPE.AUD: {
        return AUDFlag;
      }
      case COUNTRY_TYPE.CAD: {
        return CADFlag;
      }
      case COUNTRY_TYPE.CHF: {
        return CHFFlag;
      }
      case COUNTRY_TYPE.EUR: {
        return EURFlag;
      }
      case COUNTRY_TYPE.GBP: {
        return GBPFlag;
      }
      case COUNTRY_TYPE.JPY: {
        return JPYFlag;
      }
      case COUNTRY_TYPE.NZD: {
        return NZDFlag;
      }
      case COUNTRY_TYPE.USD: {
        return USDFlag;
      }
      case COUNTRY_TYPE.ZAR: {
        return ZARFlag;
      }
      case COUNTRY_TYPE.TRY: {
        return TRYFlag;
      }
      case COUNTRY_TYPE.PLN: {
        return PLNFlag;
      }
      case COUNTRY_TYPE.MXN: {
        return MXNFlag;
      }
      case COUNTRY_TYPE.NOK: {
        return NOKFlag;
      }
      case COUNTRY_TYPE.SEK: {
        return SEKFlag;
      }
      case COUNTRY_TYPE.CNH: {
        return CNHFlag;
      }
      case COUNTRY_TYPE.CZK: {
        return CZKFlag;
      }
      case COUNTRY_TYPE.HUF: {
        return HUFFlag;
      }
      case COUNTRY_TYPE.SGD: {
        return SGDFlag;
      }
      case COUNTRY_TYPE.HKD: {
        return HKDFlag;
      }
      default: {
        return null;
      }
    }
  }, [countrySymbol]);

  if (!src) return <div className={classNames(className, styles.emptyFlag)} />;
  return <img src={src} className={classNames(styles.flagImage, { [className]: className })} alt="" />;
};
CustomFlag.propTypes = {
  country: PropTypes.oneOf(COUNTRIES_AVAILABLE_VALUES),
  className: PropTypes.string,
};
CustomFlag.defaultProps = {
  country: '',
  className: '',
};

export default memo(CustomFlag);
